import { render, staticRenderFns } from "./AddStoreGiftListComponent.vue?vue&type=template&id=ad2455a0&scoped=true"
import script from "./AddStoreGiftListComponent.vue?vue&type=script&lang=js"
export * from "./AddStoreGiftListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2455a0",
  null
  
)

export default component.exports